import { Column } from '../../../types/table';
import React from 'react';
import StbColumnManager from './StbColumnManager';

interface ThContainerProps {
  column: Column;
  className?: string;
  visibleColumns: Column[];
  permissionsId: string;
  handleSetVisibleColumns: (cols: Column[]) => void;
  enableColumnManager: boolean;
}

export const ThContainer: React.FC<
  React.PropsWithChildren<ThContainerProps>
> = ({
  column,
  className,
  visibleColumns,
  permissionsId,
  handleSetVisibleColumns,
  children,
  enableColumnManager,
}) => {
  return (
    <div slot={`column-${column.id}`}>
      <div
        className={`flex justify-between items-center w-max relative ${className}`}
      >
        <div className='w-max'>{children ?? column.name}</div>
      </div>
      <div
        key={`column-${column.id}-bottom`}
        slot={`column-${column.id}-bottom`}
        style={{ width: `{column.width}px` }}
      >
        <div className='absolute left-[calc(100%_-_16px)] top-1'>
          {enableColumnManager && (
            <StbColumnManager
              selectedColumns={visibleColumns}
              column={column}
              setColumns={handleSetVisibleColumns}
              permissionsId={permissionsId}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const thTemplate = (
  column,
  visibleColumns,
  permissionsId,
  handleSetVisibleColumns,
  enableColumnManager = true,
  className?,
) => {
  switch (column.columnType) {
    default:
      return (
        <ThContainer
          className={className}
          key={`column-${column.id}`} 
          column={column}
          visibleColumns={visibleColumns}
          handleSetVisibleColumns={handleSetVisibleColumns}
          permissionsId={permissionsId}
          enableColumnManager={enableColumnManager}
        ></ThContainer>
      );
  }
};

export default thTemplate;
